/**
 * Safely extract data from API response
 * Handles cases where response.data or response.data.data might be undefined
 * 
 * @param {Object} response - Amplify API response
 * @param {*} defaultValue - Default value if data is undefined (default: [])
 * @returns {*} The extracted data or default value
 */
export const getResponseData = (response, defaultValue = []) => {
  return response?.data?.data ?? defaultValue;
};

/**
 * Safely extract data from API response, returns null as default
 * Use this when you expect a single object rather than an array
 * 
 * @param {Object} response - Amplify API response
 * @returns {*} The extracted data or null
 */
export const getResponseDataOrNull = (response) => {
  return response?.data?.data ?? null;
};

/**
 * Check if API response has valid data
 * 
 * @param {Object} response - Amplify API response
 * @returns {boolean}
 */
export const hasResponseData = (response) => {
  return response?.data?.data != null && 
         (Array.isArray(response.data.data) ? response.data.data.length > 0 : true);
};

/**
 * Safely extract a nested property from API response data
 * Use this when the response data is an object with a specific property you need
 * 
 * @param {Object} response - Amplify API response
 * @param {string} prop - Property name to extract from response.data.data
 * @param {*} defaultValue - Default value if property is undefined (default: [])
 * @returns {*} The extracted property value or default value
 */
export const getResponseDataProp = (response, prop, defaultValue = []) => {
  return response?.data?.data?.[prop] ?? defaultValue;
};
